// components/CachedImg.jsx
import React from "react";
import { useCachedImage } from "./useCachedImage";

export default function CachedImg({ src, alt = "", className = "", ttlDays, keyPrefix }) {
  const { src: cachedSrc } = useCachedImage(src, { ttlDays, keyPrefix });
  return <img src={cachedSrc || src} alt={alt} className={className} loading="lazy" decoding="async" />;
}
